import { CycleCountReportDetailsComponent } from './cycle-count-details.component';
export default CycleCountReportDetailsComponent;
